import { FC } from "react"
import { Help, Text } from "dash-styled"

type CommonParameterProps = {
    title?: string
    description?: string
    children: React.ReactElement
    required?: boolean
    containerClassName?: string
}

export const CommonParameter: FC<CommonParameterProps> = ({
    title,
    description,
    children,
    required,
    containerClassName
}) => (
    <div className="flex items-center justify-between w-full">
        {title && (
            <div className="flex items-center">
                <Text>
                    {title}
                    {required ? "*" : ""}
                </Text>
                {description && (
                    <Help
                        className="mx-1"
                        text={description}
                        tooltipPlacement="bottom"
                    />
                )}
            </div>
        )}
        <div
            className={`${containerClassName ?? ""} ${
                title ? "w-2/3" : "w-full"
            }`}
        >
            {children}
        </div>
    </div>
)
